import { Route, Routes } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import CreateRoomPage from './pages/CreateRoomPage';
import JoinRoomPage from './pages/JoinRoomPage';
import GameLobbyPage from './pages/GameLobbyPage';
import GameTablePage from './pages/GameTablePage';
import WriteInModalPage from './pages/WriteInModalPage';
import JudgeRevealPage from './pages/JudgeRevealPage';
import RoundWinnerPage from './pages/RoundWinnerPage';
import GameOverPage from './pages/GameOverPage';
import HowToPlayPage from './pages/HowToPlayPage';
import StatesPage from './pages/StatesPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/create" element={<CreateRoomPage />} />
      <Route path="/join" element={<JoinRoomPage />} />
      <Route path="/lobby" element={<GameLobbyPage />} />
      <Route path="/game" element={<GameTablePage />} />
      <Route path="/write-in" element={<WriteInModalPage />} />
      <Route path="/judge" element={<JudgeRevealPage />} />
      <Route path="/round-winner" element={<RoundWinnerPage />} />
      <Route path="/game-over" element={<GameOverPage />} />
      <Route path="/how-to-play" element={<HowToPlayPage />} />
      <Route path="/states" element={<StatesPage />} />
    </Routes>
  );
}
